import { ArrowLeft, FileText, ShieldCheck } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import './LegalDocumentPage.css';

const TERMS = [
  ['一、协议范围', ['本协议由您与小影平台运营方（具体主体以平台公示及付款凭证为准）共同订立，适用于小影网页端、创作工具、Agent、素材、模板、点数、订阅及相关服务。', '您注册、登录、勾选同意或实际使用服务，即表示已阅读并接受本协议；如不同意，请停止注册和使用。']],
  ['二、账号与安全', ['您应提供真实、准确、合法的信息并妥善保管账号、密码和验证设备，不得出租、出借、出售或以其他方式转让账号。', '发现异常登录、凭据泄露或未经授权的操作时，请立即修改凭据并通过帮助中心联系我们。因您主动泄露或违反安全提示造成的损失，由您依法承担。']],
  ['三、AI 创作服务', ['小影提供剧本写作、画布编排、图片与视频生成、素材管理等辅助创作能力。生成结果具有概率性，不保证完全准确、唯一、连续或适用于特定商业目的。', '您应在发布、投放或商业使用前自行审核事实、版权、肖像、商标、广告合规及内容安全；涉及医疗、法律、金融等专业领域时，应取得具备资质人员的独立意见。']],
  ['四、用户内容与知识产权', ['您保留对合法上传内容享有的权利，并授予平台为提供、维护、排障和改进您所请求服务所必需的、非独占的处理权限。', '您不得上传或生成侵犯他人著作权、肖像权、隐私权、商业秘密或其他合法权益的内容，也不得利用服务制作违法、有害、欺诈、仇恨、色情、暴力或规避监管的内容。', '平台软件、界面、模型编排、商标及平台提供的官方素材受法律保护。除另有明确授权外，不得反向工程、批量抓取、绕过限制或转售平台能力。']],
  ['五、点数、订阅与支付', ['Tapies 为平台内用于计量创作服务的虚拟点数，不是法定货币，不具备提现、转账或投资属性。价格、有效期、赠送规则和消耗顺序以购买页面及订单快照为准。', '微信、支付宝或银行转账仅在渠道回调验签、人工核验并完成平台入账后视为支付完成。请勿重复支付；对公转账必须使用真实付款信息和银行流水。', '退款、取消、套餐变更和发票规则以结算页及适用法律为准。依法应退的款项按原支付路径或双方确认的方式处理。']],
  ['六、服务管理', ['为保护用户、平台和第三方安全，平台可对异常请求、疑似欺诈、侵权或违法内容采取提示、限制、暂停、删除或终止服务等必要措施，并在法律允许范围内提供申诉渠道。', '因维护、升级、网络、第三方服务或不可抗力可能导致短时中断。平台会在合理范围内恢复服务并保留必要的运行记录。']],
  ['七、责任边界与争议解决', ['平台依法承担因自身过错造成的责任，但不对超出合理控制范围的第三方服务故障、用户违规操作或未经审核直接发布生成内容造成的损失承担不应由平台承担的责任。', '本协议适用中华人民共和国法律。争议应先友好协商；协商不成的，依法向有管辖权的人民法院提起诉讼。']],
  ['八、协议更新与联系', ['因法律、产品或安全要求变化，本协议可能更新。重大变化会通过页面提示、站内消息等合理方式通知；更新生效后继续使用服务，视为接受更新内容。', '如对账号、付费、知识产权或本协议有疑问，可通过小影帮助中心提交问题。']],
];

const PRIVACY = [
  ['一、我们处理的信息', ['账号信息：手机号、邮箱、微信开放平台标识、昵称、头像、地区以及您主动填写的资料。', '创作与业务信息：项目、剧本、画布节点、提示词、上传素材、生成结果、团队关系、订单、点数流水、发票资料、企业认证资料、营业执照及对公转账凭证。', '设备与日志信息：IP 地址、设备标识、浏览器类型、登录时间、操作日志、错误信息及安全风控所需的网络和设备特征。']],
  ['二、处理目的与依据', ['我们为完成注册登录、身份验证、创作生成、云端保存、团队协作、计费结算、发票交付、客户支持、安全风控和履行法定义务处理必要信息。', '非必要功能会在适当位置征得授权；您可以拒绝非必要信息，但部分对应功能可能无法使用。']],
  ['三、AI 与第三方服务', ['在您发起生成时，完成任务所必需的提示词、参考素材或参数可能被传输给已接入的模型、云存储、支付、短信、邮件等服务提供方。我们要求其仅在受托范围内处理信息并采取合理安全措施。', '具体模型和渠道会随产品配置变化。我们不会因接入第三方而免除依法承担的个人信息保护责任。']],
  ['四、共享、转让与公开披露', ['除取得单独同意、完成您主动请求、依法履行义务、保护重大合法权益或企业依法重组等情形外，我们不会向无关第三方出售或共享您的个人信息。', '公开发布作品、加入团队、分享邀请链接等由您主动触发的功能，可能使指定信息对其他用户可见，请在操作前确认范围。']],
  ['五、存储期限与地点', ['我们在实现处理目的所必需的最短期限内保存信息；订单、支付、发票、审计和安全日志按照法律规定或争议处理需要保存。期限届满后将删除、匿名化或依法隔离保存。', '原则上，境内收集和产生的个人信息存储在境内。发生跨境处理时，将依法履行告知、评估、认证、合同或单独同意等义务。']],
  ['六、您的权利', ['您可以查看和修改个人资料、导出部分账户数据、管理登录设备，并依法请求查阅、复制、更正、补充或删除个人信息。', '您可以注销账号或撤回非必要授权；法律要求留存的交易、发票和安全记录在保存期内会被限制使用，而非立即删除。']],
  ['七、安全保护', ['我们通过访问控制、传输加密、最小权限、审计日志、备份和异常监测等措施保护信息。互联网服务无法保证绝对安全；发生可能影响您权益的事件时，我们会依法处置并通知。']],
  ['八、未成年人', ['小影主要面向具备完全民事行为能力的创作者。未满十八周岁的用户应在监护人指导下使用；未满十四周岁的儿童使用涉及个人信息的服务前，应取得监护人同意。']],
  ['九、政策更新与联系', ['我们会根据法律和产品变化更新本政策。重大变化会通过页面、站内消息或其他合理方式提示。', '如需行使个人信息权利或反馈隐私问题，可通过小影帮助中心提交申请，我们将在验证身份后依法处理。']],
];

export default function LegalDocumentPage() {
  const { pathname } = useLocation();
  const privacy = pathname === '/privacy';
  const sections = privacy ? PRIVACY : TERMS;
  return (
    <main className="legal-page">
      <header className="legal-topbar">
        <Link to="/login"><ArrowLeft size={15} />返回登录</Link>
        <span><ShieldCheck size={14} />小影合规中心</span>
      </header>
      <article className="legal-document">
        <div className="legal-document__heading">
          <span><FileText size={16} />LEGAL</span>
          <h1>{privacy ? '小影隐私政策' : '小影用户协议'}</h1>
          <p>生效日期：2026年8月20日 · 更新日期：2026年8月20日</p>
        </div>
        <nav aria-label="法律文件切换">
          <Link className={!privacy ? 'is-active' : ''} to="/terms">用户协议</Link>
          <Link className={privacy ? 'is-active' : ''} to="/privacy">隐私政策</Link>
        </nav>
        <p className="legal-document__lead">请在使用小影前仔细阅读本文件，尤其是与账号安全、AI 内容、付费结算、个人信息和责任边界有关的条款。</p>
        <div className="legal-document__sections">
          {sections.map(([title, paragraphs]) => (
            <section key={title}>
              <h2>{title}</h2>
              {paragraphs.map(paragraph => <p key={paragraph}>{paragraph}</p>)}
            </section>
          ))}
        </div>
      </article>
    </main>
  );
}
